import Button, { ButtonModeE } from "../../components/Button/Button";
import usePopup from "../../utils/hooks/usePopup";

import styles from "./createNewMediaCompanyShort.module.scss";

const CreateNewMediaCompanyShortFooter = () => {
  const { removePopup } = usePopup();

  return (
    <div className={styles.buttonsWrapper}>
      <Button mode={ButtonModeE.OUTLINED} onClick={removePopup}>
        Cancel
      </Button>
      <Button form="create-media-company-short" useGlobalLoading>
        Save media company
      </Button>
    </div>
  );
};

export default CreateNewMediaCompanyShortFooter;
